import React from 'react';
import ServicesList from '../components/services/ServicesList';
import Process from '../components/services/Process';

const Services: React.FC = () => {
  return (
    <div>
      <section className="bg-primary/10 py-16">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-dark mb-6">
              Nossos Serviços
            </h1>
            <p className="text-lg text-gray-600">
              Conheça os tratamentos estéticos de excelência oferecidos pela BotoHarmony. Todos os nossos procedimentos são realizados por profissionais qualificados, utilizando produtos e tecnologias de ponta para garantir resultados naturais e harmoniosos.
            </p>
          </div>
        </div>
      </section>
      
      <ServicesList />
      <Process />
    </div>
  );
};

export default Services;